import styled, { keyframes } from 'styled-components';

const keyFramesShake = keyframes`
    25% {
        translate: 6px 0;
    }
    50% {
        translate: -6px 0;
    }
    75% {
        translate: 6px 0;
    }
`

export const StyledMain = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
`;

export const DivSearchMain = styled.div`
    background: ${(props) => props.theme.surface};
    border: 1px solid ${(props) => props.theme.borderStrong};
    border-radius: ${(props) => props.theme.radius.sm};
    padding: 0.4rem 0.6rem;
    display: inline-flex;
    justify-content: center;
    align-items: center;
    margin: 1.5rem 0.8rem;
    position: relative;
    transition: border-color 0.12s ease;
    &:focus-within {
        border-color: ${(props) => props.theme.accent};
    }
    &.invalid-input{
        border-color: ${(props) => props.theme.danger};
        animation: 0.2s 2;
        animation-name: ${keyFramesShake};
    }
`

export const InputMain = styled.input`
    width: 475px;
    height: 30px;
    border: none;
    font-size: 0.9rem;
    outline: none;
    background-color: transparent;
    color: inherit;
    font-family: inherit;
    &::placeholder {
        color: ${(props) => props.theme.text3};
    }
`

export const LoopSearchMain = styled.i`
    cursor: pointer;
    font-size: 1.30rem;
    width: 25px;
    text-align: center;
    color: ${(props) => props.theme.text2};
    transition: color .12s ease-in-out;
    &:hover {
        color: ${(props) => props.theme.accent};
    }
`

export const MenuSearchMainAdvanced = styled.i`
    cursor: pointer;
    font-size: 1.30rem;
    width: 25px;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    padding-top: 2px;
    color: ${(props) => props.theme.text2};
    transition: color .12s ease-in-out;
    &:hover {
        color: ${(props) => props.theme.accent};
    }
`

export const DivSearchMainAdvanced = styled.div`
    background: ${(props) => props.theme.surface};
    border: 1px solid ${(props) => props.theme.borderStrong};
    border-radius: ${(props) => props.theme.radius.sm};
    padding: 0.4rem 0.6rem;
    margin: 1.5rem 0.8rem;
    position: relative;
    height: 32px;
    display: flex;
    gap: 1rem;
    & span {
        display: flex;
        justify-content: center;
        align-items: center;
        height: 100%;
    }
`

export const DivLabelLine = styled.div`
    position: absolute;
    top: -11px;
    z-index: 1;
    background-color: ${(props) => props.theme.ground};
    font-size: ${(props) => props.theme.type.caption};
    color: ${(props) => props.theme.text3};
    padding: 0px 3px;
`

export const DivSearchDropdown = styled.div `
    position: absolute;
    top: 60px;
    left: 50%;
    height: 250px;
    box-sizing: content-box;
    width: auto;
    background-color: ${(props) => props.theme.surface};
    border: 1px solid ${(props) => props.theme.border};
    border-radius: ${(props) => props.theme.radius.md};
    box-shadow: ${(props) => props.theme.shadowMd};
    z-index: 2;
    padding: 15px;
    display: flex;
    flex-direction: column;
    overflow: auto;
    gap: 0.5rem;
    &.active {
        opacity: 1;
        visibility: visible;
        transform: translate(-50%, 0);
        transition: .2s ease;
    };
    &.inactive {
        opacity: 0;
        visibility: hidden;
        transform: translate(-50%, -10px);
        transition: .2s ease;
    };
    & .button-remove-filter {
        display: block;
        width: 35px;
    };
    & .button-remove-filter.disabled {
        cursor: not-allowed;
        background-color: ${(props) => props.theme.surface2};
    };
    & :last-child > .div-filter-informations > .inactive, :last-child > .div-filter-properties > .inactive {
        display: none;
    };
`

export const DivContainerSearchRow = styled.div `
    display: flex;
    gap: 20px;
`

export const RightArrowDropdown = styled.i`
    font-size: 1.30rem;
    width: 25px;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
`

export const DivSearchExportCSV = styled.div`
    background: ${(props) => props.theme.surface};
    border: 1px solid ${(props) => props.theme.borderStrong};
    border-radius: ${(props) => props.theme.radius.sm};
    padding: 0.4rem 0.6rem;
    margin: 1.5rem 0.8rem;
    position: relative;
    height: 32px;
    display: flex;
    gap: 1rem;
    cursor: pointer;
    transition: background-color .12s ease;
    align-items: center;
    &:hover {
        background-color: ${(props) => props.theme.surface3};
    };
    & span {
        display: flex;
        justify-content: center;
        align-items: center;
        height: 100%;
    };
`

export const DivSearchError = styled.div`
    color: ${(props) => props.theme.danger};
    text-align: center;
`

export const DivApplyFilters = styled.div`
    background: ${(props) => props.theme.accent};
    color: ${(props) => props.theme.onAccent};
    border: 1px solid transparent;
    border-radius: ${(props) => props.theme.radius.sm};
    padding: 0.4rem 0.8rem;
    margin: 1.5rem 0.8rem;
    position: relative;
    height: 32px;
    display: flex;
    gap: 1rem;
    cursor: pointer;
    font-weight: 700;
    transition: background-color .12s ease;
    align-items: center;
    &:hover {
        background-color: ${(props) => props.theme.accentHover};
    };
`

export const DivColumnVisibility = styled.div`
    background: ${(props) => props.theme.surface};
    border: 1px solid ${(props) => props.theme.borderStrong};
    border-radius: ${(props) => props.theme.radius.sm};
    padding: 0.4rem 0.6rem;
    margin: 1.5rem 0.8rem;
    position: relative;
    height: 32px;
    display: flex;
    gap: 1rem;
    & span {
        display: flex;
        justify-content: center;
        align-items: center;
        height: 100%;
    };
`

export const DivContainerColumnRow = styled.div`
    display: flex;
    gap: 1rem;
    align-items: center;
    border-radius: ${(props) => props.theme.radius.sm};
    padding: 0 0.4rem;
    transition: background-color .12s ease;
    &:hover {
        background-color: ${(props) => props.theme.surface3};
    };
`

export const IconCheck = styled.i`
`

export const ButtonAddRow = styled.button`
    background-color: ${(props) => props.theme.surface};
    border: 1px solid ${(props) => props.theme.borderStrong};
    border-radius: ${(props) => props.theme.radius.sm};
    height: 35px;
    font-size: inherit;
    color: inherit;
    font-family: inherit;
    font-weight: 700;
    cursor: pointer;
    padding: 0px 10px;
    transition: background-color .12s ease;
    width: 35px;
    &:hover {
        background-color: ${(props) => props.theme.surface3};
    };
`

export const SuggestionsList = styled.ul`
    position: absolute;
    top: 100%;
    left: -1px;
    right: -1px;
    margin-top: 5px;
    background-color: ${(props) => props.theme.surface};
    color: inherit;
    border: 1px solid ${(props) => props.theme.border};
    border-radius: ${(props) => props.theme.radius.md};
    box-shadow: ${(props) => props.theme.shadowMd};
    max-height: 250px;
    overflow-y: auto;
    z-index: 1000;
    list-style: none;
    padding: 4px;
`;

export const SuggestionItem = styled.li`
    padding: 8px 12px;
    cursor: pointer;
    font-size: ${(props) => props.theme.type.body};
    border-radius: ${(props) => props.theme.radius.sm};
    transition: background-color 0.12s ease;
    &:hover {
        background-color: ${(props) => props.theme.surface3};
    }
`;

export const DivOrSeparator = styled.div`
    display: flex;
    align-items: center;
    margin: 0.5rem 0;
    font-size: ${(props) => props.theme.type.caption};
    font-weight: 600;
    color: ${(props) => props.theme.text2};

    &::before,
    &::after {
        content: "";
        flex: 1;
        height: 1px;
        background: ${(props) => props.theme.border};
    }

    span {
        padding: 0 10px;
        white-space: nowrap;
    }
`;
